module.exports = __webpack_public_path__ + "static/media/icon-location.4dcb9f33.svg";